import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"

import Reveal from "components/utils/Reveal"

import Section from "components/atoms/SectionStyling"
import StandardPadding from "components/atoms/StandardPadding"
import FlexGrid from "components/atoms/FlexGrid"
import TweetCard from "components/molecules/TweetCard"
import Flex from "components/atoms/Flex"
import Button from "components/atoms/Button"
import SectionTitle from "components/molecules/SectionTitle"
import LoadingSpinner from "components/atoms/LoadingSpinner"
import { colors } from "utils/styled-constants"

import styles from "styles/components/sections/twitter.module.scss"

// TODO ADD PROPTYPES

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

function getTimeString(inputDate) {
  return MONTHS[inputDate.getMonth()] + " " + inputDate.getDate()
}

function getTweetScreenName(tweetObject) {
  return tweetObject?.user.screen_name
}

//alters text so RTs aren't truncated
function getTweetHTML(tweetObject) {
  if (!tweetObject.retweeted_status) {
    return editEntities(tweetObject.full_text, tweetObject.entities)
  } else {
    let retweetObject = tweetObject.retweeted_status
    return `RT <a href=https://twitter.com/${
      retweetObject.user.screen_name
    } target="_blank" rel="noopener noreferrer">@${
      retweetObject.user.screen_name
    }</a>: ${editEntities(retweetObject.full_text, retweetObject.entities)}`
  }
}

//Add <a> tags to entity urls, mentions, and hashtags, and remove links to media urls
function editEntities(fullText, entities) {
  let newText = fullText
  if (entities.urls) {
    entities.urls.forEach(url => {
      newText = newText.replace(
        url.url,
        `<a href=${url.url} target="_blank" rel="noopener noreferrer">${url.display_url}</a>`
      )
    })
  }
  if (entities.media) {
    entities.media.forEach(media => {
      newText = newText.replace(media.url, "")
    })
  }
  if (entities.user_mentions) {
    entities.user_mentions.forEach(user => {
      newText = newText.replace(
        `@${user.screen_name}`,
        `<a href=https://twitter.com/${user.screen_name} target="_blank" rel="noopener noreferrer">@${user.screen_name}</a>`
      )
    })
  }
  if (entities.hashtags) {
    entities.hashtags.forEach(hashtag => {
      newText = newText.replace(
        `#${hashtag.text}`,
        `<a href=https://twitter.com/hashtag/${hashtag.text} target="_blank" rel="noopener noreferrer">#${hashtag.text}</a>`
      )
    })
  }
  return newText
}

const Twitter = props => {
  const [tweets, setTweets] = useState([])

  useEffect(() => {
    // get tweets
    fetch(
      `https://wbcg-cors-anywhere.herokuapp.com/https://founder-partners-twitter-api.herokuapp.com/tweets/${props.username}`,
      {
        method: "GET",
      }
    )
      .then(res => res.json())
      .then(data => setTweets(data))
      .catch(error => console.log(error))
  }, [])

  const tweetCards = () => {
    return tweets.slice(0, 3).map((tweet, i) => {
      let tweetDate = new Date(tweet.created_at)
      return (
        <TweetCard
          key={i}
          bg={colors.lightBlue}
          color={colors.beige}
          boxShadow={props.twitterCardsShadow}
          time={getTimeString(tweetDate)}
          screenName={getTweetScreenName(tweet)}
          content={getTweetHTML(tweet)} //tweet.node.full_text, //.split(`http`)[0],
          link={`https://twitter.com/${tweet.user.screen_name}/status/${tweet.id_str}`}
        />
      )
    })
  }
  return (
    <Section first={props.idx === 0} {...props.section}>
      <StandardPadding>
        <Reveal>
          <SectionTitle {...props.sectionTitle} mb={6} maxWidth={42} />
          <>
            {!tweets.length && (
              <Flex justifyContent="center" alignItems="center" minHeight={19}>
                <LoadingSpinner />
              </Flex>
            )}
            <FlexGrid
              columns={{
                _: 1,
                lg: 3,
              }}
              gutter={{
                _: 4,
                lg: 5,
              }}
            >
              {tweetCards()}
            </FlexGrid>
            {props.button && (
              <Flex mt={6} alignItems="center" flexDirection="column">
                <Button className={styles.twitterLink} {...props.button} />
              </Flex>
            )}
          </>
        </Reveal>
      </StandardPadding>
    </Section>
  )
}

export default Twitter

export const query = graphql`
  fragment Twitter on ContentfulTwitter {
    section {
      ...SectionStyling
    }
    username
    button {
      ...Button
    }
  }
`
